import styled, { css } from 'styled-components'
import MaterialTab from '@material-ui/core/Tab'
import MaterialTabList from '@material-ui/lab/TabList'
import MaterialTabPanel from '@material-ui/lab/TabPanel'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
  margin-top: 40px;
  border-radius: 1.2rem;
  margin-bottom: 1rem;
`
export const WrapperType = styled.div`
  background: white;
  border-radius: 1.2rem;
  margin-top: 5rem;
  box-shadow: 0px 5px 25px #0000000d;
`
export const HeaderContainer = styled.div`
  padding-top: 2.4rem;
  padding-left: 2.4rem;
`
export const GridTitle = styled.div``
export const BoxTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
  padding-bottom: 1.4rem;
`
export const Panel = styled(MaterialTabPanel)`
  background-color: white;
  box-shadow: 0px 5px 25px #0000000d;
  border-radius: 0 1rem 1rem 1rem;
  padding: 1rem 1.6rem;
`
export const TabList = styled(MaterialTabList)`
  && {
    background-color: transparent;
    min-height: 0;
    .MuiTabs-flexContainer {
      background-color: transparent;
    }
    .MuiTabs-indicator {
      display: none;
    }
  }
`
export const Tab = styled(MaterialTab)<{ show?: boolean; isDisable?: boolean }>`
  && {
    background: transparent
      linear-gradient(180deg, #fff 0%, #fff 85%, #f2f3f7 100%) 0% 0% no-repeat
      padding-box;
    color: ${({ theme }) => theme.colors.darkGray};
    padding: 0.8rem 2.4rem;
    min-height: 0;
    ${({ show = true }) =>
      !show &&
      css`
        display: none;
      `}
    ${props =>
      props.isDisable &&
      css`
        cursor: not-allowed;
        background: #ddd;
      `}
    &:first-of-type {
      border-radius: 0.8rem 0 0 0;
    }
    &:last-of-type {
      border-radius: 0 0.8rem 0 0;
    }
    .MuiTab-wrapper {
      font-size: 1.2rem;
      text-transform: none;
    }
    &.Mui-selected {
      background: ${({ theme }) => theme.colors.primary2};
      color: white;
    }
  }
`
export const GridFilter = styled(Grid)``
export const GridInput = styled(Grid)`
  padding-bottom: 2.9rem;
`
